import { ArrowDown2, ArrowUp2 } from "iconsax-react";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../styles/style.css";

const Sidebar = ({ item, callback, selectedTitle }) => {
  const location = useLocation();
  const [showSubItems, setShowSubItems] = useState(false);

  // Check if the current item's path matches or is a parent of the current location's pathname
  const isActive = (path, hasSubNav = false) => {
    if (hasSubNav) {
      return location.pathname.startsWith(path);
    } else {
      return location.pathname === path;
    }
  }

  return (
    <>
      <Link
        key={item.title}
        to={item.path}
        onClick={() => {
          if (!item.subNav) {
            callback(item.title);
          } else {
            setShowSubItems(!showSubItems);
          }
        }}
        className={`sidebar-link ${isActive(item.path, !!item.subNav) ? "active" : "inactive"}`}
      >
        <div className="flex">
          <item.icon
            className={`sidebar-icon ${isActive(item.path, !!item.subNav) ? "text-gray-800" : "text-white"}`}
            aria-hidden="true"
          />
          {item.title}
        </div>
        {item.subNav &&
          (showSubItems ? (
            <ArrowUp2 className="sidebar-icon h-5 w-5" />
          ) : (
            <ArrowDown2 className="sidebar-icon h-5 w-5" />
          ))}
      </Link>
      {showSubItems &&
        item.subNav.map((subItem, index) => {
          return (
            <Link
              to={subItem.path}
              key={index}
              onClick={() => callback(subItem.title)}
              className={`sidebar-link sidebar-sub-link ${isActive(subItem.path) ? "active" : "inactive"
                }`}
            >
              {subItem.title}
            </Link>
          );
        })}
    </>
  );
};

export default Sidebar;
